import { ReactElement } from 'react';
import { CircularProgress } from '@mui/material';

import { Nullable } from '~globals/types';

import { DialogImportOrdersFromCSVProps } from './types';
import DialogImportOrdersFromCSVProvider, {
  useDialogImportOrdersFromCSVContext,
} from './Context';
import DialogImportOrdersFromCSVContent from './Content';
import {
  DialogImportOrdersFromCSVContainer,
  DialogImportOrdersFromCSVLoadingContainer,
} from './styles';

const DialogImportOrdersFromCSV = (): ReactElement => {
  const {
    open,
    onClose,
    associatedCompanies: { loading: loadingAssociatedCompanies },
  } = useDialogImportOrdersFromCSVContext();

  return (
    <DialogImportOrdersFromCSVContainer open={open} onClose={onClose}>
      {loadingAssociatedCompanies && (
        <DialogImportOrdersFromCSVLoadingContainer>
          <CircularProgress color="primary" disableShrink size={80} />
        </DialogImportOrdersFromCSVLoadingContainer>
      )}

      {!loadingAssociatedCompanies && <DialogImportOrdersFromCSVContent />}
    </DialogImportOrdersFromCSVContainer>
  );
};

const WrapperDialogImportDialogImportOrdersFromCSV = ({
  open,
  onClose,
  onSubmitSuccess,
  onUpdateErrors,
  enabledFetchAssociatedCompanies = false,
}: DialogImportOrdersFromCSVProps): Nullable<ReactElement> => {
  if (!open) return null;

  return (
    <DialogImportOrdersFromCSVProvider
      open={open}
      onClose={onClose}
      onSubmitSuccess={onSubmitSuccess}
      onUpdateErrors={onUpdateErrors}
      enabledFetchAssociatedCompanies={enabledFetchAssociatedCompanies}
    >
      <DialogImportOrdersFromCSV />
    </DialogImportOrdersFromCSVProvider>
  );
};

export default WrapperDialogImportDialogImportOrdersFromCSV;
